import {sseURL} from "./Api";


export class SSEService {
    call() {
        return `${sseURL}/v1/sse/order?access-token=${localStorage.getItem('auth')}`;
    }
}
